import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
// import Tooltip from "@mui/material/Tooltip";
// import Button from "@mui/material/Button";
// import { useUserDetail } from "../hooks/userUserData";
// import { roles } from "../constants/constant";
import { PrimaryButton } from "./button";

export default function AixmAirportExportButton({
  label,
  items = [],
  handleExportXML,
  isExportXMLLoading,
  isExportXMLDisabled,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  // const userDetail = useUserDetail();
  // const isAdmin = userDetail && userDetail.role === roles.admin;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnExport = (item) => {
    handleClose();
    handleExportXML(item.value);
  };

  // if (!isAdmin) {
  //   return (
  //     <Tooltip title="Login with Admin credentials to access export features">
  //       <Button
  //         variant="contained"
  //         disableFocusRipple
  //         disableElevation
  //         disableRipple
  //         sx={{ backgroundColor: "#f3f3f3", color: "hsl(0, 0%, 50%);" }}
  //       >
  //         {label}
  //       </Button>
  //     </Tooltip>
  //   );
  // }

  return (
    <>
      <PrimaryButton
        label={label}
        id="aixm-airportexport-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        isLoading={isExportXMLLoading}
        disabled={isExportXMLDisabled || isExportXMLLoading}
        onClick={handleClick}
      />
      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "aixm-airportexport-button",
        }}
      >
        {items.map((item) => (
          <MenuItem key={item.id} onClick={() => handleOnExport(item)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
